import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="60.5" cy="60.5" r="52.5" fill="var(--blue-05)" />
        <rect
          x="8"
          y="32.272"
          width="39.7939"
          height="37.4735"
          rx="3"
          transform="rotate(-13.1353 8 32.272)"
          fill="#D4E8D1"
        />
        <circle cx="93.4666" cy="74.4667" r="23.1111" transform="rotate(-3.46742 93.4666 74.4667)" fill="#5D24FF" />
        <rect x="13" y="34.9043" width="85" height="72" rx="4" transform="rotate(-12.8503 13 34.9043)" fill="#B2CCFF" />
        <rect
          x="33.937"
          y="54.7446"
          width="69"
          height="11"
          transform="rotate(-12.8503 33.937 54.7446)"
          fill="#FBFDFF"
        />
        <rect
          x="36.3833"
          y="65.4692"
          width="69"
          height="10"
          transform="rotate(-12.8503 36.3833 65.4692)"
          fill="#FBFDFF"
        />
        <rect
          x="31.7129"
          y="44.9951"
          width="69"
          height="10"
          transform="rotate(-12.8503 31.7129 44.9951)"
          fill="#D6E6F8"
        />
        <rect
          x="36.2798"
          y="47.0305"
          width="25"
          height="3"
          rx="1.5"
          transform="rotate(-12.8503 36.2798 47.0305)"
          fill="#4C88FF"
        />
        <rect
          x="38.7266"
          y="57.7549"
          width="25"
          height="3"
          rx="1.5"
          transform="rotate(-12.8503 38.7266 57.7549)"
          fill="#4C88FF"
        />
        <rect
          x="41.1729"
          y="68.4795"
          width="25"
          height="3"
          rx="1.5"
          transform="rotate(-12.8503 41.1729 68.4795)"
          fill="#4C88FF"
        />
        <rect
          x="64.5537"
          y="40.5808"
          width="11"
          height="3"
          rx="1.5"
          transform="rotate(-12.8503 64.5537 40.5808)"
          fill="#4C88FF"
        />
        <rect
          x="20.373"
          y="53.7361"
          width="10"
          height="3"
          rx="1.5"
          transform="rotate(-12.8503 20.373 53.7361)"
          fill="#FBFDFF"
        />
        <rect
          x="22.3745"
          y="62.5107"
          width="10"
          height="3"
          rx="1.5"
          transform="rotate(-12.8503 22.3745 62.5107)"
          fill="#FBFDFF"
        />
        <rect
          x="24.3765"
          y="71.2854"
          width="10"
          height="3"
          rx="1.5"
          transform="rotate(-12.8503 24.3765 71.2854)"
          fill="#FBFDFF"
        />
        <rect
          x="67"
          y="51.3052"
          width="11"
          height="3"
          rx="1.5"
          transform="rotate(-12.8503 67 51.3052)"
          fill="#4C88FF"
        />
        <rect
          x="69.4468"
          y="62.0298"
          width="11"
          height="3"
          rx="1.5"
          transform="rotate(-12.8503 69.4468 62.0298)"
          fill="#4C88FF"
        />
        <rect
          x="81.1279"
          y="36.7998"
          width="11"
          height="3"
          rx="1.5"
          transform="rotate(-12.8503 81.1279 36.7998)"
          fill="#4C88FF"
        />
        <rect
          x="83.5742"
          y="47.5244"
          width="11"
          height="3"
          rx="1.5"
          transform="rotate(-12.8503 83.5742 47.5244)"
          fill="#4C88FF"
        />
        <rect
          x="86.021"
          y="58.2488"
          width="11"
          height="3"
          rx="1.5"
          transform="rotate(-12.8503 86.021 58.2488)"
          fill="#4C88FF"
        />
        <path d="M28.5991 31.3457L44.5132 101.108" stroke="#4D88FF" strokeWidth="0.5" />
        <path d="M33.937 54.7446L101.209 39.3987" stroke="#4C88FF" strokeWidth="0.5" />
        <path d="M31.7129 44.9951L98.9848 29.6492" stroke="#4C88FF" strokeWidth="0.5" />
        <path d="M36.3833 65.4692L103.655 50.1233" stroke="#4C88FF" strokeWidth="0.5" />
        <path d="M38.6074 75.2188L105.392 59.984" stroke="#4C88FF" strokeWidth="0.5" />
        <path
          d="M97.8728 24.7745L15.0016 43.6789L13.6672 37.8292C13.2987 36.2138 14.3095 34.6056 15.9249 34.2371L92.9463 16.6671C94.5616 16.2986 96.1699 17.3094 96.5383 18.9248L97.8728 24.7745Z"
          fill="white"
        />
        <circle cx="92.4846" cy="21.388" r="2.5" transform="rotate(-12.8503 92.4846 21.388)" fill="#4C88FF" />
        <path
          d="M102 42.5L96.6621 18.9242C96.2964 17.309 94.6909 16.2956 93.0754 16.6604L80.5 19.5"
          stroke="var(--dark-11)"
          strokeWidth="0.5"
        />
        <path d="M50 100L95 90" stroke="var(--dark-11)" strokeWidth="0.5" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M85.7195 101.608C85.5655 101.021 85.3701 100.567 85.1862 100.319C85.1608 100.285 85.168 100.236 85.2023 100.211C85.2367 100.185 85.2852 100.193 85.3106 100.227C85.5117 100.498 85.7133 100.975 85.8692 101.569C86.0256 102.164 86.1379 102.886 86.1562 103.652C86.193 105.183 85.8553 106.905 84.7319 108.163C83.6832 109.336 82.5991 109.82 81.6031 109.859C81.0852 109.88 80.5943 109.78 80.1477 109.597C80.0293 109.895 79.8877 110.185 79.723 110.457C79.2566 111.227 78.6022 111.861 77.7642 112.138C76.1253 112.68 74.9464 112.26 74.1053 111.606C73.4564 111.1 73.006 110.451 72.7038 110.016C72.618 109.892 72.5442 109.786 72.4812 109.705L72.6034 109.61C72.6725 109.699 72.7509 109.812 72.8403 109.94C73.1432 110.376 73.5729 110.995 74.2004 111.483C75.0052 112.11 76.1309 112.515 77.7155 111.991C78.5084 111.729 79.1369 111.126 79.5906 110.377C79.7514 110.111 79.8899 109.827 80.0056 109.535C79.6504 109.372 79.3259 109.158 79.0413 108.911C78.3704 108.329 77.9149 107.565 77.8061 106.873C77.7516 106.526 77.7837 106.194 77.9245 105.913C78.0659 105.63 78.3138 105.407 78.6774 105.273C79.0367 105.141 79.3517 105.131 79.6188 105.225C79.8858 105.319 80.095 105.514 80.2493 105.775C80.5559 106.294 80.6535 107.084 80.5626 107.927C80.5088 108.427 80.3885 108.949 80.2031 109.452C80.6319 109.628 81.1023 109.724 81.597 109.705C82.5431 109.668 83.5899 109.208 84.6165 108.059C85.7034 106.843 86.0377 105.166 86.0015 103.656C85.9834 102.902 85.8729 102.192 85.7195 101.608ZM80.0609 109.39C80.24 108.903 80.3564 108.396 80.4087 107.911C80.4979 107.082 80.3984 106.331 80.116 105.854C79.9758 105.617 79.7926 105.45 79.5673 105.371C79.3421 105.292 79.065 105.296 78.7307 105.419C78.4005 105.54 78.185 105.738 78.0629 105.982C77.94 106.227 77.9082 106.525 77.959 106.849C78.061 107.497 78.4931 108.231 79.1427 108.794C79.4149 109.03 79.7239 109.235 80.0609 109.39Z"
          fill="#D4E8D1"
          stroke="#D4E8D1"
          strokeWidth="0.2"
        />
        <circle cx="78" cy="78" r="2" fill="black" />
        <path
          d="M19 117C23.0815 117 32.5111 114.724 37.5778 105.62C43.9111 94.24 44.7556 78.6453 56.5778 74.4305C66.0356 71.0586 73.4667 74.4305 76 76.5379"
          stroke="black"
          strokeWidth="0.5"
          stroke-dasharray="1 1"
        />
        <path
          d="M53.0101 10.2854C52.8915 10.2624 53.8556 10.1168 53.866 10.1158C55.5279 9.95718 57.1878 9.77207 58.8449 9.57112C60.0239 9.42813 62.4577 8.63156 63.6029 9.20504C64.5106 9.65956 62.2881 11.5557 62.0568 11.7855C60.7899 13.0438 59.2036 14.2609 58.2375 15.7677C57.4706 16.9638 58.8868 17.0945 59.7928 16.9552C60.7217 16.8124 61.4382 16.5255 62.3421 16.2052C65.6179 15.0442 68.873 13.8369 72.1895 12.7855C75.4237 11.7601 78.6254 10.9706 82 10.6069"
          stroke="var(--dark-9)"
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
